import OopsOverlay from '../../common/OopsOverlay/OopsOverlay';
import template from '../../templates/mcom/OopsOverlay/OopsOverlay';

export default class extends OopsOverlay {
  constructor(options = { error: {} }) {
    options.template = template;
    super(options);
  }
}
